import { render, staticRenderFns } from "./DeleteComponents.vue?vue&type=template&id=1bad60ff&scoped=true"
import script from "./DeleteComponents.vue?vue&type=script&lang=js"
export * from "./DeleteComponents.vue?vue&type=script&lang=js"
import style0 from "./DeleteComponents.vue?vue&type=style&index=0&id=1bad60ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bad60ff",
  null
  
)

export default component.exports